export const flagPrivacy = 'flag-privacy';

export const flagB = 'flag-b';
export const flagC = 'flag-c';
